/**
 * Die Route `/documents/:id/render-input` hängt an `snakeCaseResponse`, also
 * kommen ihre OBERSTEN Schlüssel als snake_case an: `document_number`,
 * `fagg_vorzeitig`, `contract_variant`, `signature_data_url`. Die PDF-Vorlagen
 * lesen camelCase. Die verschachtelten Objekte (seller, property, offer,
 * lawyer, buyers, sellers, bestaetigung) sind in den PDF-Typen SELBST
 * snake_case und bleiben deshalb unangetastet.
 *
 * Vorher stand dafür eine Liste einzeln umbenannter Felder im
 * Übersetzungs-Dialog. Was in der Liste fehlte, fiel still weg: die
 * FAGG-Aufforderung (Punkt 11), die Bestätigungen (Punkt 10) und der
 * Gerichtsstand — eine Neu-Erzeugung machte aus „Ja" ein leeres Kästchen.
 * Eine Abbildung, die jedes Feld mitnimmt, kann diesen Fehler nicht wiederholen.
 */
export function normalizeRenderInput(raw: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(raw)) {
    out[snakeToCamel(key)] = value;
  }
  return out;
}

export function snakeToCamel(key: string): string {
  return key.replace(/_([a-z0-9])/g, (_, c: string) => c.toUpperCase());
}
